// pretty sure we're not using this screen (probably using ~/src/components/templates/Checkout/validateVerificationForm)

import { VerificationForm } from '~/components/index'

const VerificationScreen = () => <VerificationForm />

export default VerificationScreen
